import { faEye, faEyeSlash, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../App";
import LevelColourDropdown from "../../../components/dropdowns/LevelColourDropdown";
import { postMethod } from "../../../requests";
import $ from "jquery";

const ClassesLevels = () => {
    const { t } = useTranslation();
    const [levels, setLevels] = useState(null);
    const [loading, setLoading] = useState(true);
    const { checkServerData, setAlerts } = useContext(BasicContext);
    const [formChanged, setFormChanged] = useState(false);
    const [blockForm, setBlockForm] = useState(false);

    const getClassesLevels = async () => {
        const res = await postMethod("/get-classes-levels");
        if (checkServerData(res)) {
            setLevels(res.data.levels);
        }
        setLoading(false);
    };

    const classesLvlsUpdate = async () => {
        const res = await postMethod("/classes-lvls-update", { levels: levels });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "updateLvlClasses" }]);
            const list = [...levels];
            list.forEach((e) => {
                e.class_level_added = false;
            });
            setLevels(list);
            setBlockForm(false);
            setFormChanged(false);
        }
    };

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        levels.forEach((l, i) => {
            if (l.class_level_code.length === 0 || !l.class_level_code.replace(/\s+/, "")) {
                errors.push(`${t("error.lvlCodeIsEmpty")} (nr: ${i + 1})`);
                $(`#lvlCode${i}`).addClass("is-invalid");
            }
            if (l.class_level_name.length === 0 || !l.class_level_name.replace(/\s+/, "")) {
                errors.push(`${t("error.lvlNameIsEmpty")} (nr: ${i + 1})`);
                $(`#lvlName${i}`).addClass("is-invalid");
            }
            if (!l.class_level_colour) {
                errors.push(`${t("error.lvlColourIsEmpty")} (nr: ${i + 1})`);
                $(`#lvlColour${i}`).addClass("is-invalid");
            }
        });

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setBlockForm(true);
            setAlerts([{ variant: "info", message: t("info.updatingClassLvls") }]);
            classesLvlsUpdate();
        }
    };

    const addNewLevel = () => {
        const list = [...levels];
        list.push({
            class_level_id: levels.length + 1,
            class_level_code: "",
            class_level_name: "",
            class_level_active: "Y",
            class_level_colour: null,
            class_level_added: true,
        });
        setLevels(list);
        setFormChanged(true);
    };

    useEffect(() => {
        getClassesLevels();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Container>
                <Row>
                    <Col xs={12} className="px-4 px-lg-2 ">
                        <p className="h5 mt-5 mb-4">{t("classes.classesLevels")}</p>
                    </Col>
                </Row>
                <Row>
                    {loading && (
                        <Col xs={12} className="text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    )}

                    {levels && (
                        <Col xs={12} className="px-0 px-lg-3">
                            <Form onSubmit={checkValidation}>
                                <Table size="sm" borderless>
                                    <thead>
                                        <tr>
                                            <th>{t("classes.levels.lvlCode")}</th>
                                            <th>{t("classes.levels.lvlName")}</th>
                                            <th>{t("classes.levels.lvlColour")}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {levels.map((l, i) => (
                                            <tr key={i}>
                                                <td style={{ width: "5rem" }}>
                                                    <Form.Control
                                                        value={l.class_level_code}
                                                        type="text"
                                                        onChange={(e) => {
                                                            const list = [...levels];
                                                            list.forEach((el, j) => {
                                                                if (j === i) el.class_level_code = e.target.value.toUpperCase();
                                                            });
                                                            setLevels(list);
                                                            setFormChanged(true);
                                                            $(`#lvlCode${i}`).removeClass("is-invalid");
                                                        }}
                                                        size="sm"
                                                        disabled={l.class_level_active === "N"}
                                                        id={`lvlCode${i}`}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        value={l.class_level_name}
                                                        type="text"
                                                        onChange={(e) => {
                                                            const list = [...levels];
                                                            list.forEach((el, j) => {
                                                                if (j === i) el.class_level_name = e.target.value;
                                                            });
                                                            setLevels(list);
                                                            setFormChanged(true);
                                                            $(`#lvlName${i}`).removeClass("is-invalid");
                                                        }}
                                                        size="sm"
                                                        disabled={l.class_level_active === "N"}
                                                        id={`lvlName${i}`}
                                                    />
                                                </td>
                                                <td>
                                                    <LevelColourDropdown
                                                        value={l.class_level_colour}
                                                        onChange={(v) => {
                                                            const list = [...levels];
                                                            list.forEach((el, j) => {
                                                                if (j === i) el.class_level_colour = v;
                                                            });
                                                            setLevels(list);
                                                            setFormChanged(true);
                                                            $(`#lvlColour${i}`).removeClass("is-invalid");
                                                        }}
                                                        disabled={l.class_level_active === "N"}
                                                        id={`lvlColour${i}`}
                                                    />
                                                </td>
                                                <td>
                                                    {l.class_level_added ? (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-danger"
                                                            onClick={() => {
                                                                const list = [...levels];
                                                                list.splice(i, 1);
                                                                setLevels(list);
                                                                setFormChanged(true);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-secondary"
                                                            onClick={() => {
                                                                const list = [...levels];
                                                                list.forEach((el, j) => {
                                                                    if (j === i) el.class_level_active = el.class_level_active === "Y" ? "N" : "Y";
                                                                });
                                                                setLevels(list);
                                                                setFormChanged(true);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={l.class_level_active === "Y" ? faEyeSlash : faEye} />
                                                        </Button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                <Button className="mx-2" onClick={addNewLevel} variant="outline-secondary" size="sm">
                                    {t("classes.levels.addNewLevel")}
                                </Button>
                                <Button type="submit" variant="primary" disabled={blockForm || !formChanged} className="my-4 d-block mx-3">
                                    {t("saveChanges")}
                                </Button>
                            </Form>
                        </Col>
                    )}
                </Row>
            </Container>
        </Fragment>
    );
};

export default ClassesLevels;
